import React from "react";

const TOTAL_QUESTIONS = 56 + 21 + 21 + 21 + 21; // 140, Set 1 full spec count

// Flavor-text tiers, same idea as IQTester's calcIQ/iqTier/remarks — ported
// and reworded for Reunion's group-event framing rather than solo IQ scoring.
function getRemark(correctCount, total) {
  const pct = (correctCount / total) * 100;

  if (pct >= 90) return { emoji: "🏆", text: "Absolutely dominant — you barely blinked." };
  if (pct >= 75) return { emoji: "🔥", text: "Sharp, fast, and clearly having fun with it." };
  if (pct >= 55) return { emoji: "💪", text: "Solid run — you held your ground well." };
  if (pct >= 35) return { emoji: "🙂", text: "Decent showing — a few tricky ones got you." };
  return { emoji: "🎉", text: "You made it to the end — that's the real win at a Reunion." };
}

const ReunionResults = ({ score, correctCount, onExit }) => {
  const remark = getRemark(correctCount, TOTAL_QUESTIONS);

  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-10 max-w-xl mx-auto text-center">
      <div className="text-7xl mb-5">{remark.emoji}</div>

      <h1 className="text-3xl lg:text-4xl font-black mb-2">Game Complete!</h1>
      <p className="text-emerald-200 mb-8">{remark.text}</p>

      <div className="grid grid-cols-2 gap-4 mb-8">
        <div className="rounded-2xl bg-emerald-500/10 border border-emerald-500/20 p-5">
          <div className="text-xs uppercase tracking-widest text-emerald-300">Score</div>
          <div className="text-3xl font-black mt-2">{score}</div>
        </div>
        <div className="rounded-2xl bg-purple-500/10 border border-purple-500/20 p-5">
          <div className="text-xs uppercase tracking-widest text-purple-300">Correct</div>
          <div className="text-3xl font-black mt-2">
            {correctCount}/{TOTAL_QUESTIONS}
          </div>
        </div>
      </div>

      <p className="text-sm text-emerald-300 mb-6">
        Sit tight — the organiser will announce results once everyone's done.
      </p>

      {onExit && (
        <button
          onClick={onExit}
          className="rounded-2xl px-8 py-3 bg-white/10 border border-white/10 font-semibold"
        >
          Back to Lobby
        </button>
      )}
    </div>
  );
};

export default ReunionResults;
